import { useRef } from 'react';
import { IoClose } from 'react-icons/io5';
import ReactSelect from 'react-select';
import CreatableSelect from 'react-select/creatable';
import '../styles/Input.css';
import UserAvatar from './UserAvatar';

const Select = ({ label = '', showIcon = false, isDisabled = false, icon, placeholder, options, loading, name, value, onChange, onBlur, error, touched, isMulti = false, isCreatable = false, isSearch = true }) => {
    const selectRef = useRef(null);

    const styles = {
        control: (baseStyles, state) => ({
            ...baseStyles,
            background: 'transparent',
            border: 'none',
            fontSize: '13px',
            marginTop: '0px',
            cursor: "pointer",
            boxShadow: 'none',
            minHeight: "28px",
            '&:hover': {
                border: 'none',
            },
        }),
        placeholder: (baseStyles) => ({
            ...baseStyles,
            color: '#C4C0D0',
            fontSize: '13px',
            fontWeight: '400',
        }),
        container: (baseStyles) => ({
            ...baseStyles,
            width: "100%",
        }),
        valueContainer: (baseStyles) => ({
            ...baseStyles,
            padding: '0',
        }),
        input: (baseStyles) => ({
            ...baseStyles,
            margin: '0',
            padding: '0',
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        dropdownIndicator: (baseStyles) => ({
            ...baseStyles,
            padding: '0',
            color: '#000',
        }),
    }

    const SelectComponent = isCreatable ? CreatableSelect : ReactSelect;

    const formatOptionLabel = (option) => {
        if (option.showIcon) {
            if (option.image) {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <UserAvatar username={option.label} image={option.image} />
                        <span>{option.label}</span>
                    </div>
                );
            }
            else if (!option.image) {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <UserAvatar username={option.label} image={option.image} />
                        <span>{option.label}</span>
                    </div>
                );
            }
        }
        if (option.brand && option.priceSource) {
            return (
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>{option.description}</span>
                        <span style={{ color: '#666', fontSize: '0.7em' }}>{option.product} {option.manufacturer ? (`(${option.manufacturer})`) : ''}</span>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ color: '#333', fontSize: '0.9em', fontWeight: '500' }}>PKR {option.brand}</div>
                        <div style={{ color: '#666', fontSize: '0.75em' }}>{option.priceSource === "own" ? "JHPL" : option.priceSource}</div>
                    </div>
                </div>
            );
        }
        if (option.brand) {
            return (
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>{option.description}</span>
                        <span style={{ color: '#666', fontSize: '0.7em' }}>{option.product} {option.manufacturer ? (`(${option.manufacturer})`) : ''}</span>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ color: '#666', fontSize: '0.9em' }}>{option.brand}</span>
                        <span style={{ color: '#666', fontSize: '0.9em' }}>{option.priceSource}</span>
                    </div>
                </div>
            );
        }
        return option.label;
    };

    return (
        <div className='input_wrapper'>
            <div className={`input_container ${isDisabled ? 'disabled' : ''}`}>
                <label>{label}</label>
                {
                    showIcon ?
                        <div className='d-flex align-items-center gap-2'>
                            <span className='select_icon'>
                                {icon}
                            </span>
                            <SelectComponent
                                isLoading={loading}
                                innerRef={selectRef}
                                options={options}
                                placeholder={placeholder}
                                styles={styles}
                                name={name}
                                value={value}
                                onChange={onChange}
                                formatOptionLabel={formatOptionLabel}
                                onBlur={onBlur}
                                isMulti={isMulti}
                                isDisabled={isDisabled}
                                isSearchable={isSearch}
                                {...(isCreatable && {
                                    isClearable: true,
                                    formatCreateLabel: (userInput) => `Create "${userInput}"`,
                                    noOptionsMessage: () => "Type to create new tag"
                                })}
                                components={{
                                    ClearIndicator: (clearProps) => {
                                        return (
                                            <div className="select-clear-button" {...clearProps.innerProps}>
                                                <IoClose />
                                                {clearProps.children} {/* This will render the default clear icon */}
                                            </div>
                                        )
                                    }
                                }}
                            />
                        </div> :
                        <SelectComponent
                            isLoading={loading}
                            options={options}
                            placeholder={placeholder}
                            formatOptionLabel={formatOptionLabel}
                            styles={styles}
                            name={name}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            isMulti={isMulti}
                            isDisabled={isDisabled}
                            isSearchable={isSearch}
                            {...(isCreatable && {
                                isClearable: true,
                                formatCreateLabel: (userInput) => `Create "${userInput}"`,
                                noOptionsMessage: () => "Type to create new tag"
                            })}
                            components={{
                                ClearIndicator: (clearProps) => {
                                    return (
                                        <div className="select-clear-button" {...clearProps.innerProps}>
                                            <IoClose />
                                            {clearProps.children} {/* This will render the default clear icon */}
                                        </div>
                                    )
                                }
                            }}
                        />
                }
            </div>
            {touched && error && <div className="error-message" style={{ color: '#ff0000de', fontSize: '12px', marginTop: "3px", marginLeft: "5px" }}>{error}</div>}
        </div>
    )
}

export default Select